export default {
  select: {
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
};
